import { render, staticRenderFns } from "./TenantOwnerManagement.vue?vue&type=template&id=3125ccc5&scoped=true&"
import script from "./TenantOwnerManagement.vue?vue&type=script&lang=js&"
export * from "./TenantOwnerManagement.vue?vue&type=script&lang=js&"
import style0 from "./TenantOwnerManagement.vue?vue&type=style&index=0&id=3125ccc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3125ccc5",
  null
  
)

export default component.exports